/* eslint-disable react/jsx-no-target-blank */
import { useIntl } from 'react-intl'
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'
import { AsideMenuItem } from './AsideMenuItem'
import { useMenuCountStore } from '../../../../app/core/state-management/states/menuCount';
import { apiCaller } from '../../../../app/core/hooks/useApi';
import { ServiceAgent } from '../../../../app/core/services/serviceAgent';
import { useEffect } from 'react';
import { useWroteStore } from '../../../../app/core/state-management/states/wrote';
import { useCardtableStore } from '../../../../app/core/state-management/states/cardtable/index2';
import { useAuth } from '../../../../app/modules/auth';
import { isValidRole, RoleNameEnum } from '../../../../app/core/utils/util';

export function AsideMenuMain() {
  const intl = useIntl();

  const { userInfo } = useAuth();

  const { dispatch, state } = useMenuCountStore();
  const { state: worteState } = useWroteStore();
  const { state: cardtableState } = useCardtableStore();

  ///states
  const { menuCountInfo } = state;
  const { WroteList } = worteState
  const { CardTableList, RequestData } = cardtableState;

  ////handler
  const getMenuCountData = () => {
    apiCaller({
      api: ServiceAgent.cardtable.request_getmenucount,
      onSuccess(resp) {
        if (resp?.status === 200 && resp?.data?.statusCode === 200) {
          dispatch({
            payload: { menuCountInfo: resp?.data?.data },
            type: 'SET_MENUCOUNT_DATA'
          })
        }
      },
    })
  }
  const getNotifications = () => {
    apiCaller({
      api: ServiceAgent.notifications.request_getAll,
      apiArguments: {
        CurrentPage: 1,
        PageSize: 5,
      },
      onSuccess(resp) {
        if (resp?.status === 200 && resp?.data?.statusCode === 200) {
          dispatch({
            payload: { allNotifications: resp?.data?.data?.data },
            type: 'SET_NOTIFICATION_DATA'
          })
        }
      },
    })
  }

  useEffect(() => {
    getMenuCountData()
    getNotifications()
  }, [WroteList, CardTableList, RequestData])

  return (
    <>
      <AsideMenuItem
        to='/dashboard'
        icon='element-11'
        title={intl.formatMessage({ id: 'MENU.DASHBOARD' })}
      />
      {
        userInfo && !isValidRole(userInfo?.userRoles || [], RoleNameEnum.Board) && (
          <AsideMenuItemWithSub to='/cardboard' title='کارتابل' icon='document'>
            <AsideMenuItem to='/getall-cardtable-list/1' title={'تسهیلات خط اعتباری' + ' ' + menuCountInfo?.khatEtebari || '0'} hasBullet={true} />
            <AsideMenuItem to='/getall-cardtable-list/2' title={'تسهیلات منابع داخلی' + ' ' + menuCountInfo?.manabeDakheli || '0'} hasBullet={true} />
            <AsideMenuItem to='/getall-cardtable-list/3' title={'ضمانت نامه' + ' ' + menuCountInfo?.zemanatName || '0'} hasBullet={true} />
            <AsideMenuItem to='/getall-cardtable-list/4' title={'تسهیلات کارگزاری' + ' ' + menuCountInfo?.karqozari || '0'} hasBullet={true} />
            <AsideMenuItem to='/getall-cardtable-list/5' title={'سرمایه گذاری خطر پذیر' + ' ' + menuCountInfo?.khatarpazir || '0'} hasBullet={true} />
            <AsideMenuItem to='/getall-cardtable-list/6' title={'همه کارتابل ها' + ' ' + menuCountInfo?.allCardBoard || '0'} hasBullet={true} />
            <AsideMenuItem to='/cardtable-waiting-list' title={'لیست انتظار' + ' ' + menuCountInfo?.weitingList || '0'} hasBullet={true} />
            <AsideMenuItem to='/cardtable-archive-list' title={'بایگانی' + ' ' + menuCountInfo?.archiveBox || '0'} hasBullet={true} />
          </AsideMenuItemWithSub>
        )
      }
      <AsideMenuItemWithSub to='/reminder' title='رونوشت ها' icon='notepad-bookmark'>
        <AsideMenuItem to='/wrote' title={'همه رونوشت ها ' + menuCountInfo?.transcript} hasBullet={true} />
      </AsideMenuItemWithSub>
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>کاربردی</span>
        </div>
      </div>
      <AsideMenuItemWithSub to='/request' title='لیست همه درخواست ها' icon='update-file'>
        <AsideMenuItem to='/all-request/1' title='در جریان' hasBullet={true} />
        <AsideMenuItem to='/all-request/2' title='تکمیل شده' hasBullet={true} />
        <AsideMenuItem to='/all-request/3' title='عودت داده شده' hasBullet={true} />
      </AsideMenuItemWithSub>
      {
        userInfo && !isValidRole(userInfo?.userRoles || [], RoleNameEnum.Board) &&
        <AsideMenuItemWithSub to='/personel' title='پرسنل' icon='profile-circle'>
          <AsideMenuItem to='/personel-list' title='مدیریت پرسنل' hasBullet={true} />
        </AsideMenuItemWithSub>
      }
      {
        userInfo && !isValidRole(userInfo?.userRoles || [], RoleNameEnum.Board) &&
        <AsideMenuItemWithSub to='/survey' title='پرسش و پاسخ' icon='question'>
          <AsideMenuItem to='/survey-category' title='ایجاد برگه نظرسنجی' hasBullet={true} />
        </AsideMenuItemWithSub>
      }
      {
        userInfo && !isValidRole(userInfo?.userRoles || [], RoleNameEnum.Board) &&
        <AsideMenuItemWithSub title='مالی' icon='wallet'>
          <AsideMenuItem to='/all-transaction' title='همه تراکنش ها' hasBullet={true} />
        </AsideMenuItemWithSub>
      }
      {
        userInfo && !isValidRole(userInfo?.userRoles || [], RoleNameEnum.Board) &&
        <AsideMenuItem to='/tickets' icon='user' title='پشتیبانی' />
      }
      {
        userInfo && !isValidRole(userInfo?.userRoles || [], RoleNameEnum.Board) &&
        <AsideMenuItem to='/archived-document' icon='paper-clip' title='بایگانی نامه' />
      }
      {
        userInfo && !isValidRole(userInfo?.userRoles || [], RoleNameEnum.Board) &&
        <AsideMenuItem to='/plans' icon='dollar' title='مدیریت اشتراک ها' />
      }
      {
        userInfo && !isValidRole(userInfo?.userRoles || [], RoleNameEnum.Board) &&
        <AsideMenuItem to='/request-form' icon='send' title='فرم درخواست' />
      }
      {
        userInfo && !isValidRole(userInfo?.userRoles || [], RoleNameEnum.Board) &&
        <AsideMenuItem to='/letter' icon='message-question' title='نامه های دریافتی' />
      }
      {
        userInfo && !isValidRole(userInfo?.userRoles || [], RoleNameEnum.Board) &&
        <AsideMenuItem to='/support-video' icon='google-play' title='ویدئو های آموزشی' />
      }
      <AsideMenuItem to='/reports-navigate' icon='chart' title='گزارشات' />
      {
        userInfo && !isValidRole(userInfo?.userRoles || [], RoleNameEnum.Board) &&
        <AsideMenuItem to='/faq' icon='questionnaire-tablet' title='سوالات متداول' />
      }
      <AsideMenuItem to='/user-list' icon='user-tick' title='لیست کاربران' />
      {
        userInfo && !isValidRole(userInfo?.userRoles || [], RoleNameEnum.Board) &&
        <AsideMenuItemWithSub to='/setting' title='تنظیمات' icon='setting-2'>
          <AsideMenuItem to='/setting-managment' title='تنظیمات CRM' hasBullet={true} />
        </AsideMenuItemWithSub>
      }
    </>
  )
}

